import { select } from '@ptl/angular-redux-store';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { Observable, Subscription } from 'rxjs';
import { SpecialEnrollmentCircumstance } from 'src/app/angular-elements/shared/interfaces/special-enrollment-circumstances.interface';
import { DateService } from 'src/app/shared/services/date.service';

interface ComponentFormControls {
  dateOfLifeEvent: AbstractControl;
}

interface ComponentFormValuesAsJson {
  dateOfLifeEvent: moment.Moment;
}
@FormComponentLookup('special-enrollment-date-of-life-event')
@Component({
  selector: 'app-special-enrollment-date-of-life-event',
  templateUrl: './special-enrollment-date-of-life-event.component.html',
  styleUrls: ['./special-enrollment-date-of-life-event.component.scss'],
  standalone: false
})
export class SpecialEnrollmentDateOfLifeEventComponent extends FormEntryComponentClass implements OnInit, AfterViewInit, OnDestroy {

  @select(['payloadStates', 'special-enrollment-circumstance', 'lifeEvent', 'lifeEventId']) lifeEventId$: Observable<any>;
  lifeEventIdSubscription: Subscription;

  constructor(
    private dateService: DateService
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    /* Custom Validation */
    this.form.controls[this.entry?.formControlAttributes?.formControlName].addValidators([this.validate()]);
    this.form.controls[this.entry?.formControlAttributes?.formControlName].updateValueAndValidity();

    /** Rerun validation when appropriate */
    this.lifeEventIdSubscription = this.lifeEventId$.subscribe(() => {
      this.form.controls[this.entry?.formControlAttributes?.formControlName].updateValueAndValidity();
    });

  }
  
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.lifeEventIdSubscription?.unsubscribe();
  }

  dateChanged(type: any, event: any) {
    this.form.controls[this.entry?.formControlAttributes?.formControlName].updateValueAndValidity();
  }

  get componentFormControls(): ComponentFormControls {
    return this.formControls as unknown as ComponentFormControls;
  }
  get componentFormValuesAsJson(): ComponentFormValuesAsJson {
    return this.form.value as unknown as ComponentFormValuesAsJson;
  }

  validate(): ValidatorFn {
    return (control: AbstractControl) => {

      const payloadStates = this.reducerUtilityService.getPayloadStates();
      const specialEnrollmentState: SpecialEnrollmentCircumstance = payloadStates['special-enrollment-circumstance'];

      const lifeEventControl = specialEnrollmentState.lifeEvent;
      const lifeEventDateControl = this.componentFormControls.dateOfLifeEvent;


      const lifeEventValue = lifeEventControl;
      const lifeEventDateValue: moment.Moment = lifeEventDateControl.value ? this.dateService.getDateAsMoment(lifeEventDateControl.value) : null;
      
      let isValid = true;
      const errors = {
        rangeError: false,
        firstOfMonthError: false
      }

      /** Range */
      if (lifeEventValue && lifeEventDateValue) {

        errors.rangeError = !this.isValidEnrollmentDate(
          lifeEventDateValue,
          lifeEventValue.startDateRuleDays,
          lifeEventValue.endDateRuleDays
        );
        if (errors.rangeError) {
          isValid = false;
        }

        const isEventOnFirstOfMonth = lifeEventDateValue.date() === 1;
        /** Custom */
        if (this.entry.custom?.dateMustBeFirstOfMonth && !isEventOnFirstOfMonth) {
          errors.firstOfMonthError = true;
          isValid = false;
        }

      } else {
        isValid = false;
      }

      if (isValid) {
        return null;
      } else {
        if (errors.firstOfMonthError) {
          return { firstOfMonth: true };
        }
        if (errors.rangeError) {
          return { outOfRange: true };
        }
      }

    }
  }

  /**
   * 
   * @param dateToCheck - life event date
   * @param endOfDateWindow # of days BEFORE current date that event-date is valid
   * @param beginningOfDateWindow - # of days AFTER current date that event-date still valid
   * @returns 
   */
  isValidEnrollmentDate(dateToCheck: moment.Moment, endOfDateWindow: string, beginningOfDateWindow: string) {
    if (
      !(endOfDateWindow?.length > 0) &&
      !(beginningOfDateWindow?.length > 0)
    ) {
      return false;
    } else {

      const lastValidDateInWindow: moment.Moment = this.dateService.getTodayAsMoment();
      const firstValidDateInWindow: moment.Moment = this.dateService.getTodayAsMoment();

      if (endOfDateWindow && beginningOfDateWindow) {
        lastValidDateInWindow.date(lastValidDateInWindow.date() + parseInt(endOfDateWindow, 10));
        firstValidDateInWindow.date(firstValidDateInWindow.date() - parseInt(beginningOfDateWindow, 10) - 1);

        return (lastValidDateInWindow >= dateToCheck && firstValidDateInWindow <= dateToCheck) ? true : false;

      } else if (beginningOfDateWindow) {

        firstValidDateInWindow.date(firstValidDateInWindow.date() - parseInt(beginningOfDateWindow, 10) - 1);

        return (lastValidDateInWindow >= dateToCheck && firstValidDateInWindow <= dateToCheck) ? true : false;

      } else {
        console.log('something wrong in the date');
        return false;
      }

    }
  }

}
